import React from 'react';
import { useParams } from 'react-router';

import AdminBrowseHomeListPage from 'app/components/admin/browse/home/AdminBrowseHomeListPage';
import useLocaleCodes from 'app/hooks/useLocalCodes';

export function AdminBrowseHomeListPageRoute() {
  const { defaultLocaleCode } = useLocaleCodes();
  const { localeCode = defaultLocaleCode } = useParams();

  return <AdminBrowseHomeListPage localeCode={localeCode} />;
}

export default AdminBrowseHomeListPageRoute;
